import * as z from "zod/v4";

export const logRescuePanelAnalytics = {
  name: "logRescuePanelAnalytics" as const,
  input: z.object({
    sessionId: z.string(),
    type: z.enum(["viewed", "clicked"]),
    shopifyCustomerId: z.string().nullish(),
    anonymousId: z.string().optional(),
    itemQuantity: z.number(),
  }),
  output: z.object({ success: z.boolean() }),
};
